<template>
	<div class="invalidMessage">
		<p class="subtitle">Please access EnergyHub on a desktop.</p>
		<p class="text">Stay tuned for the mobile version!</p>
	</div>
</template>

<script>
export default {
	name: "InvalidMobileAccess"
}
</script>

<style scoped lang="scss">

p{
	text-align:center;

}
.invalidMessage{
	height:100%;
	display:flex;
	flex-direction: column;
	justify-content:center;
}

</style>